import type { RankedUser } from "@/types/WebUser";
import { pointsToYen } from "@/utils";
import { LaurelWreath, ThumbaCoin, ThumbaIcon, ThumbaTrophyIcon } from "@roman/shared/components/Icons";
import { cn } from "@roman/shared/utils";
import { Avatar } from "./Avatar";

const getPrizeCardColorByRankIndex = (rank: number) => {
  switch (rank) {
    case 1:
      return "bg-gradient-to-br from-[#B88100] to-[#FFD000]";
    case 2:
      return "bg-gradient-to-br from-[#7B8386] to-[#D9E5EB]";
    case 3:
      return "bg-gradient-to-br from-[#AF6D21] to-[#F8CCAC]";
    default:
      return "bg-white";
  }
};

export const UserTop3Card: React.FC<{
  user: RankedUser;
  index: number;
  isMyRank?: boolean;
}> = ({ user, index, isMyRank }) => {
  return (
    <div
      className={cn(
        "w-full rounded-ee-lg rounded-ss-lg border bg-card shadow-sm bg-gradient-to-br relative",
        getPrizeCardColorByRankIndex(index + 1),
      )}
    >
      <div
        className={cn(
          "text-[40px] leading-[40px] font-extrabold absolute top-0 left-[5px] text-white",
          isMyRank && "animate-pulse",
        )}
      >
        {user.rank}
      </div>

      <ThumbaIcon className="absolute -top-1 left-0 scale-150 text-white/10" />

      <div className="flex flex-col items-center gap-[1px] mt-[2.79px]">
        <div className="w-full h-[58px] flex items-center justify-center relative">
          {index === 0 && <LaurelWreath color="#906700" className="absolute top-0" />}

          <Avatar user={user} />
        </div>

        <div className="text-center font-sans font-bold text-[12px] leading-[140%] tracking-[-0.24px] mt-[-7px] text-white">
          {user.name}
        </div>
        <div className="flex items-end justify-center gap-1 mt-[-3px] mb-[5px]">
          <ThumbaCoin className="w-[13px] h-[13px]" />
          <div className="font-bold text-[16px] leading-[16px] tracking-[-0.32px] text-black]">
            {" "}
            {Number(user.freePoints).toLocaleString()}
            <span className="font-medium text-[12px] leading-[12px] tracking-[-0.24px] text-black"> pt</span>
          </div>
        </div>

        {user.potentialRedeemablePoints && (
          <p className="flex items-center justify-center rounded-full bg-white px-3 py-[3px] gap-1 mb-[6px]">
            <ThumbaTrophyIcon className="w-[12px] h-[12px]" />
            <div className="font-bold text-[12px] leading-normal text-[#A67606]">
              {pointsToYen(user.potentialRedeemablePoints)}
              <span className="font-bold text-[8px] leading-normal text-[#A67606]"> 円</span>
            </div>
          </p>
        )}
      </div>
    </div>
  );
};
